module.exports = __webpack_public_path__ + "img/img27.423c0255.png";